export function isOfTypeNavEntryGroup(toBeDetermined) {
    return typeof toBeDetermined.entries !== 'undefined';
}
export function getPathnamesOfItems(items) {
    const pathnames = [];
    for (const item of items) {
        if (isOfTypeNavEntryGroup(item)) {
            for (const entry of item.entries) {
                pathnames.push(entry.path);
            }
        }
        else {
            pathnames.push(item.path);
        }
    }
    return pathnames;
}
